import EventOrganizeTitle from './EventOrganizeTitle';

export default EventOrganizeTitle